import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
    `<div>
  <h4>Description - Associate Injury</h4>
  <p>
      The associate is injured and needs immediate help.
  </p>
  <h4>Resolution Steps</h4>
  <p>
      1. Reach out to the associate and ensure that the associate is safe.<br />
      2. Remove the safety hazard if any.<br />
      3. Inform the station manager/WHS POC.<br />
      4. Fill the Injury Investigation template.<br />
      5. Once you resolve the request mark task as completed.
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Injury.jsx